export enum UserRole {
  USER = "USER",
  SUPERADMIN = "SUPERADMIN"
}

export const Constants = {
  REACT_APP_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  REACT_APP_GTM_ID: import.meta.env.VITE_GTM_ID,

  WEBSOCKET_BASE_URL:
    import.meta.env.VITE_WEBSOCKET_BASE_URL ||
    "wss://api.staging.marketbuzz.ai/api/crm_service/ws",
  CLOVER_MARKETPLACE_URL:
    import.meta.env.VITE_CLOVER_MARKETPLACE_URL ||
    "https://www.clover.com/appmarket/apps/H0Q43MF9ZH86A",

  MESSAGE_SERVICE_BASE_URL:
    import.meta.env.VITE_MESSAGE_SERVICE_BASE_URL ||
    "http://localhost:3000/api/message_service",
  CLOVER_SERVICE_BASE_URL:
    import.meta.env.VITE_CLOVER_SERVICE_BASE_URL ||
    "http://localhost:8080/api/v1/clover_service/"
} as const;

export enum WebsocketMessageAction {
  //TODO: Need to refer from types. For some reason, it gives an error at the moment
  GET_SYNC_PROGRESS = "GET_SYNC_PROGRESS"
}
export const GTM = {
  events: {
    loginEvent: "loginEvent",
    logoutEvent: "logoutEvent",
    userProfileUpdateEvent: "userProfileUpdateEvent",
    campaignCreatedEvent: "campaignCreatedEvent"
  }
};

export enum Features {
  CRM = "CRM",
  ANALYTICS = "ANALYTICS"
}

export enum OrganizationStatus {
  SUSPENDED = "SUSPENDED",
  ACTIVE = "ACTIVE",
  SYNCING = "SYNCING",
  DEACTIVATED = "DEACTIVATED"
}
